// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__xSKCh","tablist":"style_tablist__jRSds","tab":"style_tab__46ayS","tabSelected":"style_tabSelected__neU_9"};